import React, { useState, useEffect } from "react";
import "../../Styles/StudentViewMarks.css";
import axios from "axios";

function StudentViewMarks() {
  const [subjects, setSubjects] = useState([]);
  const [classes, setClasses] = useState([]);
  const [examNames, setExamNames] = useState(["All"]);
  const [selectedSubject, setSelectedSubject] = useState("All");
  const [selectedClass, setSelectedClass] = useState("");
  const [selectedExam, setSelectedExam] = useState("All");
  const [marksData, setMarksData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [studentInfo, setStudentInfo] = useState(null);

  useEffect(() => {
    // Fetch student info, subjects and classes
    const fetchStudentData = async () => {
      try {
        const authToken = localStorage.getItem("authToken");
        const [studentResponse, examResponse] = await Promise.all([
          axios.get("https://api.uniums.com/api/exam/student-get-subjects", {
            headers: { Authorization: `Bearer ${authToken}` },
          }),
          axios.get("https://api.uniums.com/api/exam/student-get-exam-names", {
            headers: { Authorization: `Bearer ${authToken}` },
          }),
        ]);

        if (studentResponse.data) {
          setSubjects(["All", ...studentResponse.data.subjects]);
          setClasses(studentResponse.data.classes || []);
          setStudentInfo(studentResponse.data.studentInfo);

          if (studentResponse.data.classes?.length > 0) {
            setSelectedClass(studentResponse.data.classes[0]);
          }
        }

        if (examResponse.data) {
          setExamNames(examResponse.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setError("Failed to load student information.");
      }
    };
    fetchStudentData();
  }, []);

  useEffect(() => {
    // Fetch student marks when filters change
    const fetchMarks = async () => {
      if (!selectedClass) return;

      setLoading(true);
      setError("");

      try {
        const authToken = localStorage.getItem("authToken");
        const response = await axios.get(
          `https://api.uniums.com/api/exam/student-get-marks`,
          {
            params: {
              subject: selectedSubject,
              class: selectedClass,
              examName: selectedExam,
            },
            headers: { Authorization: `Bearer ${authToken}` },
          }
        );

        setMarksData(response.data || []);
      } catch (error) {
        console.error("Error fetching marks:", error);
        setError(error.response?.data?.message || "Failed to fetch marks.");
        setMarksData([]);
      } finally {
        setLoading(false);
      }
    };

    if (selectedClass) {
      fetchMarks();
    }
  }, [selectedSubject, selectedClass, selectedExam]);

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const filteredMarks = marksData.filter(
    (mark) =>
      mark.examName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      mark.subject?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="student-view-marks">
      <h1>View Marks</h1>

      {classes.length === 0 && (
        <p className="warning-message">
          No classes assigned to your account. Please contact your
          administrator.
        </p>
      )}

      <div className="filters-container">
        <div className="dropdown-container_view">
          <label>Class:</label>
          <select
            onChange={(e) => setSelectedClass(e.target.value)}
            value={selectedClass}
            disabled={classes.length === 0}
          >
            <option value="">Select Class</option>
            {classes.map((cls, index) => (
              <option key={index} value={cls}>
                {cls}
              </option>
            ))}
          </select>
        </div>

        <div className="dropdown-container_view">
          <label>Subject:</label>
          <select
            onChange={(e) => setSelectedSubject(e.target.value)}
            value={selectedSubject}
          >
            {subjects.map((subj, index) => (
              <option key={index} value={subj}>
                {subj}
              </option>
            ))}
          </select>
        </div>

        <div className="dropdown-container_view">
          <label>Exam:</label>
          <select
            onChange={(e) => setSelectedExam(e.target.value)}
            value={selectedExam}
          >
            {examNames.map((exam, index) => (
              <option key={index} value={exam}>
                {exam}
              </option>
            ))}
          </select>
        </div>
      </div>

      {error && <p className="error-message">{error}</p>}
      {loading && <p className="loading-text">Loading marks...</p>}

      {marksData.length > 0 && !loading && (
        <>
          <div className="search-bar">
            <input
              type="text"
              placeholder="Search by exam name or subject..."
              value={searchTerm}
              onChange={handleSearch}
              className="search-box"
            />
          </div>
          <div className="faculty-table-container">
            <table className="marks-table">
              <thead>
                <tr>
                  <th>Sl No</th>
                  <th>Exam Name</th>
                  <th>Class</th>
                  <th>Subject</th>
                  <th>Marks Obtained</th>
                  <th>Total Marks</th>
                  <th>Percentage</th>
                </tr>
              </thead>
              <tbody>
                {filteredMarks.map((mark, index) => (
                  <tr key={mark._id}>
                    <td>{index + 1}</td>
                    <td>{mark.examName}</td>
                    <td>{mark.class}</td>
                    <td>{mark.subject}</td>
                    <td>{mark.obtainedMarks}</td>
                    <td>{mark.totalMarks}</td>
                    <td>
                      {((mark.obtainedMarks / mark.totalMarks) * 100).toFixed(
                        2
                      )}
                      %
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {marksData.length === 0 && !loading && selectedClass && (
        <p className="no-results">
          No marks available for the selected criteria.
        </p>
      )}
    </div>
  );
}

export default StudentViewMarks;
